<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          COST CONSUMER
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9>
            {{ id ? 'Edit Cost Consumer' : 'Create New Cost Consumer' }}
          </v-flex>
          <v-flex xs3 class="text-right">
            <v-icon id="refresh" @click="clear" title="refresh">
              refresh
            </v-icon>
          </v-flex>
        </v-card-title>
        <ValidationObserver ref="obs">
          <v-form @submit.prevent="save" class="pa-5">
            <v-layout row wrap>
              <v-flex xs6 class="pa-0">
                <ValidationProvider
                  name="code"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text pl-5">Cost Center</label>
                  <v-autocomplete
                    id="code-group"
                    single-line
                    outlined
                    placeholder="Select Cost Center"
                    dense
                    v-model="item.code_cost_center"
                    required
                    class="px-5"
                    :items="costCenters"
                    item-value="code"
                    item-text="desc"
                    :error-messages="errors"
                    :success="valid"
                  >
                    <template slot="selection" slot-scope="data">
                      {{ data.item.code }} - {{ data.item.desc }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.code }} - {{ data.item.desc }}
                    </template>
                  </v-autocomplete>
                </ValidationProvider>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <ValidationProvider
                  name="Nature Activity"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text pl-5">Nature Activity</label>
                  <v-text-field
                    id="nature-activity"
                    single-line
                    outlined
                    placeholder="Nature Activity"
                    dense
                    v-model="item.nature_activity"
                    required
                    class="px-5"
                    :error-messages="errors"
                    :success="valid"
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <ValidationProvider
                  name="Category"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text pl-5">Category</label>
                  <v-text-field
                    id="category"
                    single-line
                    outlined
                    placeholder="Category"
                    dense
                    v-model="item.category"
                    required
                    class="px-5"
                    :error-messages="errors"
                    :success="valid"
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
            </v-layout>
            <v-card-actions class="text-right pt-9">
              <v-spacer></v-spacer>
              <v-flex xs2 right class="mr-4">
                <v-btn
                  id="btn-cancel"
                  dark
                  rounded
                  color="red"
                  block
                  :to="{ name: 'costConsumer' }"
                >
                  Cancel
                </v-btn>
              </v-flex>
              <v-flex xs2 right>
                <v-btn
                  id="btn-update"
                  dark
                  rounded
                  color="blue darken-3"
                  block
                  v-if="id"
                  type="submit"
                  >Update</v-btn
                >
                <v-btn
                  id="btn-save"
                  dark
                  rounded
                  color="blue darken-3"
                  block
                  v-else
                  type="submit"
                  >Save</v-btn
                >
              </v-flex>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '../../../components/progress_dialog';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
  components: { 'progress-dialog': ProgressDialog },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    return {
      isEdit: false,
      text: '',
      progressDialogLoading: true,
      loading: true,
      item: {
        code_cost_center: null,
        nature_activity: '',
        category: ''
      },
      search: '',
      breadcrumbs: [
        {
          text: 'Master Data',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Cost Consumer List',
          disabled: true,
          href: 'breadcrumbs_link_1'
        },
        {
          text: this.id ? 'Edit Cost Consumer' : 'Create New Cost Consumer',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      costCenters: []
    };
  },
  props: ['id'],
  mounted() {
    this.getCostCenter();
    if (this.id) {
      this.getDetail();
    } else {
      setTimeout(() => {
        this.progressDialogLoading = false;
        this.loading = false;
      }, 1000);
    }
  },
  methods: {
    getCostCenter() {
      const limit = 10000;
      this.$store
        .dispatch('costCenter/getAll', { limit })
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.costCenters = data.data.result;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          console.log(err.response);
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    getDetail() {
      this.progressDialogLoading = true;
      this.loading = true;
      this.$store
        .dispatch('costConsumer/detail', this.id)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            let item = data.data.result;
            this.item.nature_activity = item.nature_activity;
            this.item.category = item.category;
            this.item.code_cost_center = item.code_cost_center;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          console.log(err.response);
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    async clear() {
      this.item = {
        code_cost_center: null,
        category: '',
        nature_activity: ''
      };
      requestAnimationFrame(() => {
        this.$refs.obs.reset();
      });
    },
    async save() {
      const validated = await this.$refs.obs.validate();
      if (validated) {
        this.progressDialogLoading = true;
        this.loading = true;
        if (this.id) {
          this.$store
            .dispatch('costConsumer/update', {
              id: this.id,
              params: this.item
            })
            .then(data => {
              this.progressDialogLoading = false;
              this.loading = false;
              if (data.code === 200) {
                Swal.fire('Success!', data.message.text_en, 'success');
                this.clear();
                this.$router.push({
                  name: 'costConsumer'
                });
              } else {
                Swal.fire(
                  'Failed!',
                  data.response.data.message.text_en,
                  'error'
                );
              }
            })
            .catch(err => {
              console.log('error', err.response);
              Swal.fire('Failed!', err.response.data.message.text_en, 'error');
              this.progressDialogLoading = false;
              this.loading = false;
            });
        } else {
          this.$store
            .dispatch('costConsumer/create', this.item)
            .then(data => {
              this.progressDialogLoading = false;
              this.loading = false;
              if (data.code === 200) {
                Swal.fire('Success!', data.message.text_en, 'success');
                this.clear();
                this.$router.push({
                  name: 'costConsumer'
                });
              } else {
                Swal.fire('Failed!', data.data.message.text_en, 'error');
              }
            })
            .catch(err => {
              console.log('error', err);
              Swal.fire('Failed!', err.response.data.message.text_en, 'error');
              this.progressDialogLoading = false;
              this.loading = false;
            });
        }
      }
    }
  }
};
</script>
